const en = {
  seoTitle: "Buy Property in Portugal | Panatlantik International",
  seoDescription: "Register your requirements and receive carefully matched property opportunities in Portugal.",
  internationalDesk: "International Buyer Desk",
  heroTitle: "Looking to buy property in Portugal?",
  heroText: "Tell us what you are looking for. Our team will assess your requirements and identify suitable opportunities across Portugal.",
  campaignFor: "Buyer service for",
  benefitMatching: "Property matching",
  benefitConfidential: "Confidential service",
  benefitMultilingual: "Multilingual support",
  formTitle: "Register your buying requirements",
  formIntro: "We only request information needed to understand your property search. Do not submit passport or identity-document details.",
  fullName: "Full name",
  email: "Email address",
  phone: "Telephone / WhatsApp",
  nationality: "Nationality",
  currentCountry: "Current country",
  locations: "Preferred locations in Portugal",
  budgetMin: "Minimum budget (€)",
  budgetMax: "Maximum budget (€)",
  propertyType: "Property type",
  timeframe: "Purchasing timeframe",
  financing: "How will you purchase?",
  purpose: "Purpose of purchase",
  message: "Additional requirements",
  referralCode: "Referral code (optional)",
  consent: "I consent to Panatlantik processing my information to respond to this property enquiry and provide relevant property opportunities. I may withdraw my consent at any time.",
  consentRequired: "Please accept the privacy consent.",
  selectOption: "Select an option",
  apartment: "Apartment",
  house: "House",
  villa: "Villa",
  land: "Land",
  hotel: "Hotel",
  building: "Building",
  developmentProject: "Development project",
  commercialProperty: "Commercial property",
  immediate: "Immediate",
  zeroThreeMonths: "0–3 months",
  threeSixMonths: "3–6 months",
  sixTwelveMonths: "6–12 months",
  twelvePlusMonths: "12+ months",
  opportunistic: "Opportunistic",
  cash: "Cash",
  mortgage: "Mortgage",
  cashMortgage: "Cash and mortgage",
  undecided: "Undecided",
  primaryResidence: "Primary residence",
  holidayHome: "Holiday home",
  rentalIncome: "Rental income",
  development: "Property development",
  relocation: "Relocation",
  commercialInvestment: "Commercial investment",
  other: "Other",
  submitting: "Submitting…",
  submit: "Find matching properties",
  submitError: "Your request could not be submitted. Please try again.",
  noGuarantee: "Registration does not constitute financial, legal or immigration advice and does not guarantee availability or financing.",
  successTitle: "Your property search has started",
  successText: "Our team has received your requirements and will review the strongest property matches.",
  reference: "Reference",
};

const pt = {
  ...en,
  seoTitle: "Comprar imóvel em Portugal | Panatlantik International",
  seoDescription: "Registe os seus critérios e receba oportunidades imobiliárias em Portugal cuidadosamente selecionadas.",
  internationalDesk: "Departamento de Compradores Internacionais",
  heroTitle: "Pretende comprar um imóvel em Portugal?",
  heroText: "Indique-nos o que procura. A nossa equipa analisará os seus critérios e identificará oportunidades adequadas em Portugal.",
  campaignFor: "Serviço de compradores para",
  benefitMatching: "Seleção personalizada de imóveis",
  benefitConfidential: "Serviço confidencial",
  benefitMultilingual: "Apoio multilingue",
  formTitle: "Registe os seus critérios de compra",
  formIntro: "Solicitamos apenas os dados necessários para compreender a sua procura. Não introduza informações de passaporte ou de documentos de identificação.",
  fullName: "Nome completo",
  email: "Endereço de email",
  phone: "Telefone / WhatsApp",
  nationality: "Nacionalidade",
  currentCountry: "País de residência atual",
  locations: "Localizações preferidas em Portugal",
  budgetMin: "Orçamento mínimo (€)",
  budgetMax: "Orçamento máximo (€)",
  propertyType: "Tipo de imóvel",
  timeframe: "Prazo previsto para a compra",
  financing: "Como pretende financiar a compra?",
  purpose: "Finalidade da aquisição",
  message: "Critérios adicionais",
  referralCode: "Código de referência (opcional)",
  consent: "Autorizo a Panatlantik a tratar os meus dados para responder a este pedido e apresentar oportunidades imobiliárias relevantes. Posso retirar o meu consentimento a qualquer momento.",
  consentRequired: "Por favor, aceite o consentimento de privacidade.",
  selectOption: "Selecione uma opção",
  apartment: "Apartamento",
  house: "Moradia",
  villa: "Villa",
  land: "Terreno",
  hotel: "Hotel",
  building: "Edifício",
  developmentProject: "Projeto de desenvolvimento",
  commercialProperty: "Imóvel comercial",
  immediate: "Imediato",
  zeroThreeMonths: "0–3 meses",
  threeSixMonths: "3–6 meses",
  sixTwelveMonths: "6–12 meses",
  twelvePlusMonths: "Mais de 12 meses",
  opportunistic: "Oportunístico",
  cash: "Capitais próprios",
  mortgage: "Crédito hipotecário",
  cashMortgage: "Capitais próprios e crédito",
  undecided: "Ainda não decidido",
  primaryResidence: "Residência principal",
  holidayHome: "Casa de férias",
  rentalIncome: "Rendimento de arrendamento",
  development: "Desenvolvimento imobiliário",
  relocation: "Relocalização",
  commercialInvestment: "Investimento comercial",
  other: "Outra",
  submitting: "A enviar…",
  submit: "Encontrar imóveis compatíveis",
  submitError: "Não foi possível enviar o seu pedido. Por favor, tente novamente.",
  noGuarantee: "O registo não constitui aconselhamento financeiro, jurídico ou de imigração, nem garante disponibilidade ou financiamento.",
  successTitle: "A sua procura imobiliária foi iniciada",
  successText: "A nossa equipa recebeu os seus critérios e analisará as oportunidades com maior compatibilidade.",
  reference: "Referência",
};

const zh = {
  ...en,
  seoTitle: "在葡萄牙购买房产 | Panatlantik International",
  seoDescription: "提交您的购房需求，获取经过审慎筛选的葡萄牙房产机会。",
  internationalDesk: "国际买家服务部",
  heroTitle: "计划在葡萄牙购买房产？",
  heroText: "请告诉我们您的购房需求。我们的团队将进行专业评估，并为您筛选葡萄牙境内合适的房产机会。",
  campaignFor: "面向以下市场的买家服务：",
  benefitMatching: "精准房产匹配",
  benefitConfidential: "保密服务",
  benefitMultilingual: "多语言支持",
  formTitle: "登记您的购房需求",
  formIntro: "我们仅收集了解您购房需求所必需的信息。请勿提交护照或身份证件资料。",
  fullName: "姓名",
  email: "电子邮箱",
  phone: "电话 / WhatsApp",
  nationality: "国籍",
  currentCountry: "当前居住国家",
  locations: "葡萄牙首选地区",
  budgetMin: "最低预算（欧元）",
  budgetMax: "最高预算（欧元）",
  propertyType: "房产类型",
  timeframe: "计划购买时间",
  financing: "计划如何支付？",
  purpose: "购买目的",
  message: "其他需求",
  referralCode: "推荐码（选填）",
  consent: "我同意 Panatlantik 处理我的信息，以回复本次房产咨询并提供相关房产机会。我可随时撤回同意。",
  consentRequired: "请接受隐私授权。",
  selectOption: "请选择",
  apartment: "公寓",
  house: "住宅",
  villa: "别墅",
  land: "土地",
  hotel: "酒店",
  building: "整栋建筑",
  developmentProject: "开发项目",
  commercialProperty: "商业地产",
  immediate: "立即购买",
  zeroThreeMonths: "0–3个月",
  threeSixMonths: "3–6个月",
  sixTwelveMonths: "6–12个月",
  twelvePlusMonths: "12个月以上",
  opportunistic: "视合适机会而定",
  cash: "现金购买",
  mortgage: "按揭贷款",
  cashMortgage: "现金与按揭组合",
  undecided: "尚未决定",
  primaryResidence: "主要住所",
  holidayHome: "度假住宅",
  rentalIncome: "租赁收益",
  development: "房地产开发",
  relocation: "移居安置",
  commercialInvestment: "商业投资",
  other: "其他",
  submitting: "正在提交…",
  submit: "查找匹配房产",
  submitError: "未能提交您的请求，请重试。",
  noGuarantee: "登记不构成金融、法律或移民建议，亦不保证房产供应或融资获批。",
  successTitle: "您的房产搜索已启动",
  successText: "我们的团队已收到您的需求，并将审核匹配度最高的房产机会。",
  reference: "查询编号",
};


const fr = {
  ...en,
  seoTitle: "Acheter un bien immobilier au Portugal | Panatlantik International",
  seoDescription: "Enregistrez vos critères et recevez des opportunités immobilières soigneusement sélectionnées au Portugal.",
  internationalDesk: "Service des acheteurs internationaux",
  heroTitle: "Vous souhaitez acheter un bien immobilier au Portugal ?",
  heroText: "Présentez-nous votre projet. Notre équipe étudiera vos critères et identifiera les opportunités adaptées au Portugal.",
  campaignFor: "Service d’accompagnement destiné aux acheteurs de",
  benefitMatching: "Sélection personnalisée de biens",
  benefitConfidential: "Service confidentiel",
  benefitMultilingual: "Accompagnement multilingue",
  formTitle: "Enregistrez vos critères d’acquisition",
  formIntro: "Nous demandons uniquement les informations nécessaires à la compréhension de votre recherche. Ne communiquez aucune donnée de passeport ou de pièce d’identité.",
  fullName: "Nom complet",
  email: "Adresse e-mail",
  phone: "Téléphone / WhatsApp",
  nationality: "Nationalité",
  currentCountry: "Pays de résidence actuel",
  locations: "Localisations privilégiées au Portugal",
  budgetMin: "Budget minimum (€)",
  budgetMax: "Budget maximum (€)",
  propertyType: "Type de bien",
  timeframe: "Délai prévu pour l’acquisition",
  financing: "Comment financerez-vous l’acquisition ?",
  purpose: "Objectif de l’acquisition",
  message: "Critères complémentaires",
  referralCode: "Code de recommandation (facultatif)",
  consent: "J’autorise Panatlantik à traiter mes informations afin de répondre à cette demande et de me présenter des opportunités immobilières pertinentes. Je peux retirer mon consentement à tout moment.",
  consentRequired: "Veuillez accepter le consentement relatif à la confidentialité.",
  selectOption: "Sélectionnez une option",
  apartment: "Appartement",
  house: "Maison",
  villa: "Villa",
  land: "Terrain",
  hotel: "Hôtel",
  building: "Immeuble",
  developmentProject: "Projet de développement",
  commercialProperty: "Bien commercial",
  immediate: "Immédiat",
  zeroThreeMonths: "0–3 mois",
  threeSixMonths: "3–6 mois",
  sixTwelveMonths: "6–12 mois",
  twelvePlusMonths: "Plus de 12 mois",
  opportunistic: "Selon les opportunités",
  cash: "Fonds propres",
  mortgage: "Crédit immobilier",
  cashMortgage: "Fonds propres et crédit",
  undecided: "Pas encore décidé",
  primaryResidence: "Résidence principale",
  holidayHome: "Résidence de vacances",
  rentalIncome: "Revenus locatifs",
  development: "Développement immobilier",
  relocation: "Relocalisation",
  commercialInvestment: "Investissement commercial",
  other: "Autre",
  submitting: "Envoi en cours…",
  submit: "Trouver les biens correspondants",
  submitError: "Votre demande n’a pas pu être envoyée. Veuillez réessayer.",
  noGuarantee: "L’inscription ne constitue pas un conseil financier, juridique ou migratoire et ne garantit ni la disponibilité d’un bien ni l’obtention d’un financement.",
  successTitle: "Votre recherche immobilière a commencé",
  successText: "Notre équipe a reçu vos critères et examinera les opportunités présentant la meilleure compatibilité.",
  reference: "Référence",
};

const es = {
  ...en,
  seoTitle: "Comprar una propiedad en Portugal | Panatlantik International",
  seoDescription: "Registre sus criterios y reciba oportunidades inmobiliarias en Portugal cuidadosamente seleccionadas.",
  internationalDesk: "Departamento de Compradores Internacionales",
  heroTitle: "¿Desea comprar una propiedad en Portugal?",
  heroText: "Indíquenos qué está buscando. Nuestro equipo evaluará sus criterios e identificará oportunidades adecuadas en Portugal.",
  campaignFor: "Servicio para compradores de",
  benefitMatching: "Selección personalizada de propiedades",
  benefitConfidential: "Servicio confidencial",
  benefitMultilingual: "Asistencia multilingüe",
  formTitle: "Registre sus criterios de compra",
  formIntro: "Solicitamos únicamente la información necesaria para comprender su búsqueda. No facilite datos de pasaporte ni de documentos de identidad.",
  fullName: "Nombre completo",
  email: "Correo electrónico",
  phone: "Teléfono / WhatsApp",
  nationality: "Nacionalidad",
  currentCountry: "País de residencia actual",
  locations: "Ubicaciones preferidas en Portugal",
  budgetMin: "Presupuesto mínimo (€)",
  budgetMax: "Presupuesto máximo (€)",
  propertyType: "Tipo de propiedad",
  timeframe: "Plazo previsto para la compra",
  financing: "¿Cómo financiará la compra?",
  purpose: "Finalidad de la adquisición",
  message: "Criterios adicionales",
  referralCode: "Código de referencia (opcional)",
  consent: "Autorizo a Panatlantik a tratar mis datos para responder a esta solicitud y presentarme oportunidades inmobiliarias relevantes. Puedo retirar mi consentimiento en cualquier momento.",
  consentRequired: "Acepte el consentimiento de privacidad.",
  selectOption: "Seleccione una opción",
  apartment: "Apartamento",
  house: "Casa",
  villa: "Villa",
  land: "Terreno",
  hotel: "Hotel",
  building: "Edificio",
  developmentProject: "Proyecto de desarrollo",
  commercialProperty: "Inmueble comercial",
  immediate: "Inmediato",
  zeroThreeMonths: "0–3 meses",
  threeSixMonths: "3–6 meses",
  sixTwelveMonths: "6–12 meses",
  twelvePlusMonths: "Más de 12 meses",
  opportunistic: "Según la oportunidad",
  cash: "Fondos propios",
  mortgage: "Financiación hipotecaria",
  cashMortgage: "Fondos propios y financiación",
  undecided: "Aún no decidido",
  primaryResidence: "Residencia principal",
  holidayHome: "Vivienda vacacional",
  rentalIncome: "Ingresos por alquiler",
  development: "Desarrollo inmobiliario",
  relocation: "Reubicación",
  commercialInvestment: "Inversión comercial",
  other: "Otra",
  submitting: "Enviando…",
  submit: "Encontrar propiedades compatibles",
  submitError: "No se ha podido enviar su solicitud. Inténtelo de nuevo.",
  noGuarantee: "El registro no constituye asesoramiento financiero, jurídico o migratorio, ni garantiza la disponibilidad o la financiación.",
  successTitle: "Su búsqueda inmobiliaria ha comenzado",
  successText: "Nuestro equipo ha recibido sus criterios y analizará las oportunidades con mayor compatibilidad.",
  reference: "Referencia",
};


const de = {
  ...en,
  seoTitle: "Immobilien in Portugal kaufen | Panatlantik International",
  seoDescription: "Registrieren Sie Ihre Suchkriterien und erhalten Sie sorgfältig ausgewählte Immobilienangebote in Portugal.",
  internationalDesk: "Internationaler Käuferservice",
  heroTitle: "Möchten Sie eine Immobilie in Portugal kaufen?",
  heroText: "Teilen Sie uns Ihre Suchkriterien mit. Unser Team analysiert Ihren Bedarf und ermittelt passende Immobilienangebote in Portugal.",
  campaignFor: "Käuferservice für",
  benefitMatching: "Individuelle Immobilienauswahl",
  benefitConfidential: "Vertraulicher Service",
  benefitMultilingual: "Mehrsprachige Betreuung",
  formTitle: "Registrieren Sie Ihre Kaufkriterien",
  formIntro: "Wir erheben nur die Informationen, die zur Bearbeitung Ihrer Immobiliensuche erforderlich sind. Bitte übermitteln Sie keine Pass- oder Ausweisdaten.",
  fullName: "Vollständiger Name",
  email: "E-Mail-Adresse",
  phone: "Telefon / WhatsApp",
  nationality: "Staatsangehörigkeit",
  currentCountry: "Aktuelles Wohnsitzland",
  locations: "Bevorzugte Standorte in Portugal",
  budgetMin: "Mindestbudget (€)",
  budgetMax: "Höchstbudget (€)",
  propertyType: "Immobilienart",
  timeframe: "Geplanter Kaufzeitraum",
  financing: "Wie möchten Sie den Kauf finanzieren?",
  purpose: "Zweck des Erwerbs",
  message: "Weitere Anforderungen",
  referralCode: "Empfehlungscode (optional)",
  consent: "Ich willige ein, dass Panatlantik meine Angaben verarbeitet, um meine Immobilienanfrage zu beantworten und mir passende Angebote zu unterbreiten. Ich kann meine Einwilligung jederzeit widerrufen.",
  consentRequired: "Bitte stimmen Sie der Datenschutzerklärung zu.",
  selectOption: "Option auswählen",
  apartment: "Wohnung",
  house: "Haus",
  villa: "Villa",
  land: "Grundstück",
  hotel: "Hotel",
  building: "Gebäude",
  developmentProject: "Entwicklungsprojekt",
  commercialProperty: "Gewerbeimmobilie",
  immediate: "Sofort",
  zeroThreeMonths: "0–3 Monate",
  threeSixMonths: "3–6 Monate",
  sixTwelveMonths: "6–12 Monate",
  twelvePlusMonths: "Mehr als 12 Monate",
  opportunistic: "Bei passender Gelegenheit",
  cash: "Eigenkapital",
  mortgage: "Hypothekenfinanzierung",
  cashMortgage: "Eigenkapital und Finanzierung",
  undecided: "Noch nicht entschieden",
  primaryResidence: "Hauptwohnsitz",
  holidayHome: "Ferienimmobilie",
  rentalIncome: "Mieteinnahmen",
  development: "Immobilienentwicklung",
  relocation: "Umzug nach Portugal",
  commercialInvestment: "Gewerbliche Investition",
  other: "Sonstiges",
  submitting: "Wird übermittelt…",
  submit: "Passende Immobilien finden",
  submitError: "Ihre Anfrage konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.",
  noGuarantee: "Die Registrierung stellt keine Finanz-, Rechts- oder Einwanderungsberatung dar und garantiert weder Verfügbarkeit noch Finanzierung.",
  successTitle: "Ihre Immobiliensuche wurde gestartet",
  successText: "Unser Team hat Ihre Kriterien erhalten und prüft nun die am besten passenden Immobilienangebote.",
  reference: "Referenz",
};

const it = {
  ...en,
  seoTitle: "Acquistare un immobile in Portogallo | Panatlantik International",
  seoDescription: "Registri i suoi criteri e riceva opportunità immobiliari in Portogallo accuratamente selezionate.",
  internationalDesk: "Servizio Acquirenti Internazionali",
  heroTitle: "Desidera acquistare un immobile in Portogallo?",
  heroText: "Ci indichi ciò che sta cercando. Il nostro team analizzerà i suoi criteri e individuerà le opportunità più adatte in Portogallo.",
  campaignFor: "Servizio dedicato agli acquirenti di",
  benefitMatching: "Selezione personalizzata degli immobili",
  benefitConfidential: "Servizio riservato",
  benefitMultilingual: "Assistenza multilingue",
  formTitle: "Registri i suoi criteri di acquisto",
  formIntro: "Richiediamo esclusivamente le informazioni necessarie per comprendere la sua ricerca. Non inserisca dati del passaporto o di documenti d’identità.",
  fullName: "Nome completo",
  email: "Indirizzo e-mail",
  phone: "Telefono / WhatsApp",
  nationality: "Nazionalità",
  currentCountry: "Paese di residenza attuale",
  locations: "Località preferite in Portogallo",
  budgetMin: "Budget minimo (€)",
  budgetMax: "Budget massimo (€)",
  propertyType: "Tipologia di immobile",
  timeframe: "Tempistica prevista per l’acquisto",
  financing: "Come intende finanziare l’acquisto?",
  purpose: "Finalità dell’acquisto",
  message: "Ulteriori requisiti",
  referralCode: "Codice di segnalazione (facoltativo)",
  consent: "Autorizzo Panatlantik a trattare i miei dati per rispondere a questa richiesta e propormi opportunità immobiliari pertinenti. Posso revocare il consenso in qualsiasi momento.",
  consentRequired: "Accetti il consenso relativo alla privacy.",
  selectOption: "Selezioni un’opzione",
  apartment: "Appartamento",
  house: "Casa",
  villa: "Villa",
  land: "Terreno",
  hotel: "Hotel",
  building: "Edificio",
  developmentProject: "Progetto di sviluppo",
  commercialProperty: "Immobile commerciale",
  immediate: "Immediato",
  zeroThreeMonths: "0–3 mesi",
  threeSixMonths: "3–6 mesi",
  sixTwelveMonths: "6–12 mesi",
  twelvePlusMonths: "Oltre 12 mesi",
  opportunistic: "In presenza dell’opportunità giusta",
  cash: "Capitale proprio",
  mortgage: "Mutuo",
  cashMortgage: "Capitale proprio e mutuo",
  undecided: "Non ancora deciso",
  primaryResidence: "Residenza principale",
  holidayHome: "Casa vacanze",
  rentalIncome: "Rendita da locazione",
  development: "Sviluppo immobiliare",
  relocation: "Trasferimento",
  commercialInvestment: "Investimento commerciale",
  other: "Altro",
  submitting: "Invio in corso…",
  submit: "Trova gli immobili compatibili",
  submitError: "Non è stato possibile inviare la richiesta. Riprovi.",
  noGuarantee: "La registrazione non costituisce consulenza finanziaria, legale o in materia di immigrazione e non garantisce disponibilità o finanziamento.",
  successTitle: "La sua ricerca immobiliare è iniziata",
  successText: "Il nostro team ha ricevuto i suoi criteri e valuterà le opportunità con il livello di compatibilità più elevato.",
  reference: "Riferimento",
};

const ru = {
  ...en,
  seoTitle: "Купить недвижимость в Португалии | Panatlantik International",
  seoDescription: "Зарегистрируйте свои критерии и получайте тщательно отобранные предложения недвижимости в Португалии.",
  internationalDesk: "Отдел по работе с иностранными покупателями",
  heroTitle: "Планируете приобрести недвижимость в Португалии?",
  heroText: "Расскажите нам о своих требованиях. Наша команда проанализирует их и подберёт подходящие объекты недвижимости в Португалии.",
  campaignFor: "Сервис для покупателей из",
  benefitMatching: "Персональный подбор недвижимости",
  benefitConfidential: "Конфиденциальное обслуживание",
  benefitMultilingual: "Многоязычная поддержка",
  formTitle: "Зарегистрируйте свои критерии покупки",
  formIntro: "Мы запрашиваем только сведения, необходимые для понимания вашего запроса. Не указывайте паспортные данные или сведения удостоверения личности.",
  fullName: "Полное имя",
  email: "Адрес электронной почты",
  phone: "Телефон / WhatsApp",
  nationality: "Гражданство",
  currentCountry: "Текущая страна проживания",
  locations: "Предпочтительные регионы Португалии",
  budgetMin: "Минимальный бюджет (€)",
  budgetMax: "Максимальный бюджет (€)",
  propertyType: "Тип недвижимости",
  timeframe: "Планируемый срок покупки",
  financing: "Как будет финансироваться покупка?",
  purpose: "Цель приобретения",
  message: "Дополнительные требования",
  referralCode: "Реферальный код (необязательно)",
  consent: "Я разрешаю Panatlantik обрабатывать мои данные для ответа на этот запрос и предоставления подходящих предложений недвижимости. Я могу отозвать согласие в любое время.",
  consentRequired: "Пожалуйста, примите согласие на обработку данных.",
  selectOption: "Выберите вариант",
  apartment: "Квартира",
  house: "Дом",
  villa: "Вилла",
  land: "Земельный участок",
  hotel: "Отель",
  building: "Здание",
  developmentProject: "Девелоперский проект",
  commercialProperty: "Коммерческая недвижимость",
  immediate: "Немедленно",
  zeroThreeMonths: "0–3 месяца",
  threeSixMonths: "3–6 месяцев",
  sixTwelveMonths: "6–12 месяцев",
  twelvePlusMonths: "Более 12 месяцев",
  opportunistic: "При подходящей возможности",
  cash: "Собственные средства",
  mortgage: "Ипотека",
  cashMortgage: "Собственные средства и ипотека",
  undecided: "Решение ещё не принято",
  primaryResidence: "Основное место жительства",
  holidayHome: "Дом для отдыха",
  rentalIncome: "Доход от аренды",
  development: "Девелопмент недвижимости",
  relocation: "Переезд",
  commercialInvestment: "Коммерческие инвестиции",
  other: "Другое",
  submitting: "Отправка…",
  submit: "Найти подходящие объекты",
  submitError: "Не удалось отправить запрос. Пожалуйста, попробуйте ещё раз.",
  noGuarantee: "Регистрация не является финансовой, юридической или иммиграционной консультацией и не гарантирует доступность объектов или получение финансирования.",
  successTitle: "Поиск недвижимости начат",
  successText: "Наша команда получила ваши критерии и рассмотрит предложения с наибольшей степенью соответствия.",
  reference: "Номер запроса",
};


const internalDashboard = {
  en: {
    internalTitle: "International Buyers",
    internalSubtitle: "International buyer leads, qualification and property requirements",
    openPublicForm: "Open public form",
    totalLeads: "Total leads",
    hotLeads: "Hot",
    qualifiedLeads: "Qualified",
    nurturingLeads: "Nurturing",
    searchLeads: "Search name, country, location or property type",
    allClassifications: "All classifications",
    noLeads: "No international buyer leads yet",
    noLeadsText: "New registrations from the public Buyer Finder will appear here automatically.",
    international: "International",
    budget: "Budget",
    language: "Language",
    viewRequirement: "View requirement",
    status_hot: "Hot",
    status_qualified: "Qualified",
    status_nurturing: "Nurturing",
  },
  pt: {
    internalTitle: "Compradores Internacionais",
    internalSubtitle: "Contactos internacionais, qualificação e critérios de aquisição",
    openPublicForm: "Abrir formulário público",
    totalLeads: "Total de contactos",
    hotLeads: "Prioritário",
    qualifiedLeads: "Qualificado",
    nurturingLeads: "Em acompanhamento",
    searchLeads: "Pesquisar nome, país, localização ou tipo de imóvel",
    allClassifications: "Todas as classificações",
    noLeads: "Ainda não existem compradores internacionais",
    noLeadsText: "Os novos registos do formulário público aparecerão aqui automaticamente.",
    international: "Internacional",
    budget: "Orçamento",
    language: "Idioma",
    viewRequirement: "Ver requisito",
    status_hot: "Prioritário",
    status_qualified: "Qualificado",
    status_nurturing: "Em acompanhamento",
  },
  zh: {
    internalTitle: "国际买家",
    internalSubtitle: "国际买家线索、资格评估与购房需求",
    openPublicForm: "打开公开表单",
    totalLeads: "买家总数",
    hotLeads: "高优先级",
    qualifiedLeads: "已确认资格",
    nurturingLeads: "持续培育",
    searchLeads: "按姓名、国家、地区或房产类型搜索",
    allClassifications: "所有分类",
    noLeads: "暂无国际买家线索",
    noLeadsText: "通过公开买家表单提交的新登记将自动显示在此处。",
    international: "国际",
    budget: "预算",
    language: "语言",
    viewRequirement: "查看购房需求",
    status_hot: "高优先级",
    status_qualified: "已确认资格",
    status_nurturing: "持续培育",
  },
  fr: {
    internalTitle: "Acheteurs internationaux",
    internalSubtitle: "Prospects internationaux, qualification et critères d’acquisition",
    openPublicForm: "Ouvrir le formulaire public",
    totalLeads: "Total des prospects",
    hotLeads: "Prioritaire",
    qualifiedLeads: "Qualifié",
    nurturingLeads: "À accompagner",
    searchLeads: "Rechercher par nom, pays, localisation ou type de bien",
    allClassifications: "Toutes les classifications",
    noLeads: "Aucun acheteur international pour le moment",
    noLeadsText: "Les nouvelles inscriptions du formulaire public apparaîtront automatiquement ici.",
    international: "International",
    budget: "Budget",
    language: "Langue",
    viewRequirement: "Voir les critères",
    status_hot: "Prioritaire",
    status_qualified: "Qualifié",
    status_nurturing: "À accompagner",
  },
  es: {
    internalTitle: "Compradores internacionales",
    internalSubtitle: "Contactos internacionales, cualificación y criterios de compra",
    openPublicForm: "Abrir formulario público",
    totalLeads: "Total de contactos",
    hotLeads: "Prioritario",
    qualifiedLeads: "Cualificado",
    nurturingLeads: "En seguimiento",
    searchLeads: "Buscar por nombre, país, ubicación o tipo de propiedad",
    allClassifications: "Todas las clasificaciones",
    noLeads: "Todavía no hay compradores internacionales",
    noLeadsText: "Los nuevos registros del formulario público aparecerán aquí automáticamente.",
    international: "Internacional",
    budget: "Presupuesto",
    language: "Idioma",
    viewRequirement: "Ver criterios",
    status_hot: "Prioritario",
    status_qualified: "Cualificado",
    status_nurturing: "En seguimiento",
  },
  de: {
    internalTitle: "Internationale Käufer",
    internalSubtitle: "Internationale Interessenten, Qualifizierung und Kaufkriterien",
    openPublicForm: "Öffentliches Formular öffnen",
    totalLeads: "Interessenten insgesamt",
    hotLeads: "Hohe Priorität",
    qualifiedLeads: "Qualifiziert",
    nurturingLeads: "In Betreuung",
    searchLeads: "Nach Name, Land, Standort oder Immobilienart suchen",
    allClassifications: "Alle Klassifizierungen",
    noLeads: "Noch keine internationalen Käufer",
    noLeadsText: "Neue Registrierungen über das öffentliche Formular erscheinen automatisch hier.",
    international: "International",
    budget: "Budget",
    language: "Sprache",
    viewRequirement: "Suchkriterien anzeigen",
    status_hot: "Hohe Priorität",
    status_qualified: "Qualifiziert",
    status_nurturing: "In Betreuung",
  },
  it: {
    internalTitle: "Acquirenti internazionali",
    internalSubtitle: "Contatti internazionali, qualificazione e criteri di acquisto",
    openPublicForm: "Apri il modulo pubblico",
    totalLeads: "Totale contatti",
    hotLeads: "Prioritario",
    qualifiedLeads: "Qualificato",
    nurturingLeads: "In accompagnamento",
    searchLeads: "Cerca per nome, Paese, località o tipologia di immobile",
    allClassifications: "Tutte le classificazioni",
    noLeads: "Nessun acquirente internazionale",
    noLeadsText: "Le nuove registrazioni dal modulo pubblico appariranno automaticamente qui.",
    international: "Internazionale",
    budget: "Budget",
    language: "Lingua",
    viewRequirement: "Visualizza i criteri",
    status_hot: "Prioritario",
    status_qualified: "Qualificato",
    status_nurturing: "In accompagnamento",
  },
  ru: {
    internalTitle: "Международные покупатели",
    internalSubtitle: "Международные обращения, квалификация и критерии покупки",
    openPublicForm: "Открыть публичную форму",
    totalLeads: "Всего обращений",
    hotLeads: "Высокий приоритет",
    qualifiedLeads: "Квалифицирован",
    nurturingLeads: "На сопровождении",
    searchLeads: "Поиск по имени, стране, региону или типу недвижимости",
    allClassifications: "Все категории",
    noLeads: "Обращений международных покупателей пока нет",
    noLeadsText: "Новые регистрации из публичной формы будут автоматически отображаться здесь.",
    international: "Международный",
    budget: "Бюджет",
    language: "Язык",
    viewRequirement: "Посмотреть критерии",
    status_hot: "Высокий приоритет",
    status_qualified: "Квалифицирован",
    status_nurturing: "На сопровождении",
  },
};

export default {
  en: { ...en, ...internalDashboard.en },
  pt: { ...pt, ...internalDashboard.pt },
  zh: { ...zh, ...internalDashboard.zh },
  fr: { ...fr, ...internalDashboard.fr },
  es: { ...es, ...internalDashboard.es },
  de: { ...de, ...internalDashboard.de },
  it: { ...it, ...internalDashboard.it },
  ru: { ...ru, ...internalDashboard.ru },
};
